import * as types from '../mutation-types'
import { i18n } from '../../plugins'

// state
export const state = {
	language: 'da' // chosen language
}

// mutations
export const mutations = {
	[types.SET_LANGUAGE] (state, payload) {
		state.language = payload.data
		i18n.locale = payload.data
		window.localStorage.language = payload.data
	}
}

// actions
export const actions = {
	setLanguage: ({ commit }, data) => {
		commit([types.SET_LANGUAGE], { data })
	}
}

// getters
export const getters = {
	Language: state => state.language
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js